// extracted by mini-css-extract-plugin
module.exports = {"content":"FleetListMovileViewColumn_content__3OGTN","actions":"FleetListMovileViewColumn_actions__s97N3"};